<div id="modal-content-wrapper">
    <header id="modal-header">
        <h1 i18n  id="modal-title">Edit Profile</h1>
    </header>
    <section id="modal-body">
        <div *ngIf="avatar_allow">
            <div class="avatar-upload">
                <div class="avatar-edit">
                    <!-- <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg, .svg" (change)="imageProcess()"/> -->
                    <button i18n id="imageUpload" (click)="imageProcess()"></button>
                    <label i18n for="imageUpload"></label>
                </div>
                <div class="avatar-reset">
                    <!-- <input type='file' id="imageUpload" accept=".png, .jpg, .jpeg, .svg" (change)="imageProcess()"/> -->
                    <button i18n id="imageReset" (click)="resetNodeImage()"></button>
                    <label i18n for="imageReset"></label>
                </div>
                <div class="avatar-preview">
                    <div id="imagePreview3" [ngStyle]="{'background-image': 'url(' + imgURL + ')'}">
                    </div>
                </div>
            </div>
        </div>
        <form class="row" *ngIf="avatar_allow">
            <mat-form-field appearance="fill" class="col-6">
                <mat-label i18n>Profile Visibility</mat-label>
                <mat-select (selectionChange)="profileSetting($event.value)" name='profile_info'>
                    <mat-option i18n value="SHOW">SHOW</mat-option>
                    <mat-option i18n value="HIDE">HIDE</mat-option>
                </mat-select>
            </mat-form-field>
        </form>
        <form class="row">
            <mat-form-field class="col-6">
                <mat-label i18n>FirstName</mat-label>
                <input matInput placeholder="Ex. William" [(ngModel)]="firstname" autocomplete="off" name="firstname">
                <mat-hint i18n style="color: #f44336;" *ngIf="firstname=='n/a' || firstname==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>

            <mat-form-field class="col-6">
                <mat-label i18n>LastName</mat-label>
                <input matInput placeholder="Ex. Clinton" [(ngModel)]="lastname" autocomplete="off" name="lastname">
                <mat-hint i18n style="color: #f44336;" *ngIf="lastname=='n/a' || lastname==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
        </form>
        <form class="row" *ngIf="birth_allow">
            <mat-form-field class="col-12">
                <mat-label i18n>Birth Place</mat-label>
                <input matInput placeholder="Ex. Coffee Co. AL" [(ngModel)]="birthplace" autocomplete="off"
                    name="birthplace">
                <mat-hint i18n style="color: #f44336;" *ngIf="birthplace=='n/a' || birthplace==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
        </form>
        <form class="row" *ngIf="birth_allow">
            <mat-form-field class="col-4">
                <mat-label i18n>Birth Year</mat-label>
                <input matInput placeholder="Ex. 1888" [(ngModel)]="birthyear" autocomplete="off" name="birthyear">
                <mat-hint i18n style="color: #f44336;" *ngIf="birthyear=='-' || birthyear==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
            <mat-form-field class="col-4">
                <mat-label i18n>Birth Month</mat-label>
                <input matInput placeholder="Ex. 1" [(ngModel)]="birthmonth" autocomplete="off" name="birthmonth">
                <mat-hint i18n style="color: #f44336;" *ngIf="birthmonth=='-' || birthmonth==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
            <mat-form-field class="col-4">
                <mat-label i18n>Birth Day</mat-label>
                <input matInput placeholder="Ex. 1" [(ngModel)]="birthday" autocomplete="off" name="birthday">
                <mat-hint i18n style="color: #f44336;" *ngIf="birthday=='-' || birthday==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
        </form>
        <form class="row" *ngIf="death_allow">
            <mat-form-field class="col-12">
                <mat-label i18n>Death Place</mat-label>
                <input matInput placeholder="Ex. Coffee Co. AL" [(ngModel)]="deathplace" autocomplete="off"
                    name="deathplace">
                <mat-hint i18n style="color: #f44336;" *ngIf="deathplace=='n/a' || deathplace==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
        </form>
        <form class="row" *ngIf="death_allow">
            <mat-form-field class="col-4">
                <mat-label i18n>Death Year</mat-label>
                <input matInput placeholder="Ex. 1888" [(ngModel)]="deathyear" autocomplete="off" name="deathyear">
                <mat-hint i18n style="color: #f44336;" *ngIf="deathyear=='-' || deathyear==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
            <mat-form-field class="col-4">
                <mat-label i18n>Death Month</mat-label>
                <input matInput placeholder="Ex. 1" [(ngModel)]="deathmonth" autocomplete="off" name="deathmonth">
                <mat-hint i18n style="color: #f44336;" *ngIf="deathmonth=='-' || deathmonth==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
            <mat-form-field class="col-4">
                <mat-label i18n>Death Day</mat-label>
                <input matInput placeholder="Ex. 1" [(ngModel)]="deathday" autocomplete="off" name="deathday">
                <mat-hint i18n style="color: #f44336;" *ngIf="deathday=='-' || deathday==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
        </form>
        <form class="row" *ngIf="marriage_allow">
            <mat-form-field class="col-12">
                <mat-label i18n>Marriage Place</mat-label>
                <input matInput placeholder="Ex. Coffee Co. AL" [(ngModel)]="marriageplace" autocomplete="off"
                    name="marriageplace">
                <mat-hint i18n style="color: #f44336;" *ngIf="marriageplace=='n/a' || marriageplace==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
        </form>
        <form class="row" *ngIf="marriage_allow">
            <mat-form-field class="col-4">
                <mat-label i18n>Marriage Year</mat-label>
                <input matInput placeholder="Ex. 1888" [(ngModel)]="marriageyear" autocomplete="off"
                    name="marriageyear">
                <mat-hint i18n style="color: #f44336;" *ngIf="marriageyear=='-' || marriageyear==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
            <mat-form-field class="col-4">
                <mat-label i18n>Marriage Month</mat-label>
                <input matInput placeholder="Ex. 1" [(ngModel)]="marriagemonth" autocomplete="off" name="marriagemonth">
                <mat-hint i18n style="color: #f44336;" *ngIf="marriagemonth=='-' || marriagemonth==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
            <mat-form-field class="col-4">
                <mat-label i18n>Marriage Day</mat-label>
                <input matInput placeholder="Ex. 1" [(ngModel)]="marriageday" autocomplete="off" name="marriageday">
                <mat-hint i18n style="color: #f44336;" *ngIf="marriageday=='-' || marriageday==''">
                    Please enter a valid info
                </mat-hint>
            </mat-form-field>
        </form>
        <div *ngIf="country_allow">
            <mat-radio-group aria-label="Select an option" [(ngModel)]="flag_type">
                <mat-grid-list cols="2" rowHeight="70px">
                    <mat-grid-tile>
                        <mat-radio-button i18n value="origin" style="font-size: 16px;">&nbsp;Own</mat-radio-button>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <mat-radio-button i18n value="custom" style="font-size: 16px;">&nbsp;Custom</mat-radio-button>
                    </mat-grid-tile>
                </mat-grid-list>
            </mat-radio-group>
        </div>
        <div *ngIf="country_allow && flag_type=='origin'">
            <form [(value)]="country" class="col-6">
                <mat-form-field appearance="fill">
                    <mat-label i18n>Select Nationality</mat-label>
                    <mat-select (selectionChange)="selectCountry($event.value)" name='country'>
                        <mat-option i18n *ngFor="let country of country_list" [value]="country">{{country}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
        </div>
        <div *ngIf="country_allow && flag_type=='custom'" style="text-align: center;">
            <input type='file' #imageUpload accept=".png, .jpg, .jpeg, .svg" (change)="setFlag($event)"
                style="display:none" />
            <mat-form appearance="fill" style="text-align: center;">
                <button i18n mat-button color="accent" (click)="imageUpload.click()" style="border: solid 1px;">Select
                    Flag</button>
            </mat-form>
        </div>

        <form class="row">
            <mat-form-field class="col-12">
                <mat-label i18n>Note:</mat-label>
                <textarea matInput [(ngModel)]="note" autocomplete="off" name="note"></textarea>
            </mat-form-field>

        </form>

    </section>
    <footer id="modal-footer">
        <button i18n mat-raised-button id="modal-action-button" (click)="actionFunction()">
            Save
        </button>
        <button i18n mat-raised-button id="modal-cancel-button" (click)="closeModal()">
            Close
        </button>
    </footer>
</div>